import { render } from "./DotQue.vue?vue&type=template&id=589a8779&ts=true"
import script from "./DotQue.vue?vue&type=script&lang=ts"
export * from "./DotQue.vue?vue&type=script&lang=ts"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__